"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = exports.Description = exports.DropContainerWrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const loader_svg_1 = __importDefault(require("@svg/loader.svg"));
const ResponsiveStyles_1 = require("@components/typography/ResponsiveStyles");
exports.DropContainerWrapper = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  align-items: self-start;
  justify-content: end;
  height: 100%;
  @media (max-width: 1200px) {
    justify-content: center;
  }
  @media (max-width: 700px) {
    flex-wrap: wrap-reverse;
  }
`;
exports.Description = styled_components_1.default.div `
  font-size: 30px;
  font-weight: bold;
  color: white;
  text-align: center;
  ${ResponsiveStyles_1.responsiveDescriptionStyles}
  @media (max-width:409px) {
    padding: 0;
    display: flex;
  }
`;
const LoaderBox = styled_components_1.default.span `
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  animation: spin 1s linear infinite;
  position: fixed;
  top: calc(35% - 100px);
  left: calc(50% - 100px);
`;
const LoaderWrapper = styled_components_1.default.div `
  background: rgba(255, 255, 255, 0.2);
  position: fixed;
  z-index: 9999;
  display: block;
  text-align: center;
  width: 100vw;
  height: 100vh;
  top: 0;
`;
const Loader = () => react_1.default.createElement(LoaderWrapper, null,
    react_1.default.createElement(LoaderBox, null,
        react_1.default.createElement(loader_svg_1.default, null)));
exports.Loader = Loader;
